"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CatchFromControl = void 0;
var _CatchFromControlContext = _interopRequireDefault(require("./CatchFromControlContext"));
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CatchFromControl = exports.CatchFromControl = function CatchFromControl(_ref) {
  var children = _ref.children;
  var fromControl = (0, _material.useFormControl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CatchFromControlContext["default"].Provider, {
    value: {
      fromControl: fromControl
    },
    children: children
  });
};

// Needed to fix initialFilled in FormControl
CatchFromControl.muiName = 'Input';
var _default = exports["default"] = CatchFromControl;